module.exports = __webpack_public_path__ + "img/marker-car.6189d21b.svg";